import { render, staticRenderFns } from "./ammeter.vue?vue&type=template&id=4160d881&scoped=true&"
import script from "./ammeter.vue?vue&type=script&lang=js&"
export * from "./ammeter.vue?vue&type=script&lang=js&"
import style0 from "./ammeter.vue?vue&type=style&index=0&id=4160d881&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4160d881",
  null
  
)

export default component.exports